// extracted by mini-css-extract-plugin
export default {"btn":"submit-btn_btn__0dCp7","icon":"submit-btn_icon__vll+o"};